import { createContext } from 'react';

export type ScreenType = 'desktop' | 'laptop' | 'tablet' | 'mobile';

type ScreenTypeContextProps = {
  screenType: ScreenType;
};

export const ScreenTypeContext = createContext<ScreenTypeContextProps | undefined>(undefined);
